import {
  EnumDataModelV2UpgradeState as UpgradeState,
  EnumGenericJobStatus as JobStatus,
} from '../../graphql/types';

interface Input {
  upgradeState?: UpgradeState | null;
  usesGroupsSince?: unknown;
  promptDismissed: boolean;
  manuallyOpened: boolean;
  jobLoaded: boolean;
  jobStatus?: JobStatus;
}

export function resolveUpgradeStatus({
  upgradeState,
  usesGroupsSince,
  promptDismissed,
  manuallyOpened,
  jobLoaded,
  jobStatus,
}: Input): 'ready' | 'upgrading' | 'failure' | 'success' | null {
  if (upgradeState === UpgradeState.upgrade_acknowledged) return null;
  if (upgradeState === UpgradeState.upgrade_completed) return 'success';

  if (upgradeState === UpgradeState.upgrade_started) {
    if (!jobLoaded) return null;
    return jobStatus === JobStatus.failed ? 'failure' : 'upgrading';
  }

  if (usesGroupsSince != null) return null;

  const emailSent = upgradeState === UpgradeState.sent_email || upgradeState === UpgradeState.clicked_email;
  if (manuallyOpened || (emailSent && !promptDismissed)) {
    return 'ready';
  }
  return null;
}
